export function trainingLimit(day) {
    const value = Number(day && day.growthLimit != null ? day.growthLimit : 12);
    return Number.isInteger(value) && value >= 1 ? value : 12;
}

// Pure transaction callback: validate every date before changing any roster.
export function addTrainingApplicants(current, dates, className, name) {
    if (!Array.isArray(current) || !dates.length || !['훈련반', '특강반'].includes(className)) return;
    const selected = [...new Set(dates)];
    for (const date of selected) {
        const day = current.find(day => day && day.date === date);
        if (!day) return;
        if (className === '특강반' && (day.user || []).filter(user => user.class === '특강반').length >= trainingLimit(day)) return;
    }
    return current.map(day => day && selected.includes(day.date)
        ? { ...day, user: [...(day.user || []), { name, paid: false, class: className }] }
        : day);
}
